import { createFileRoute, Link, useParams } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { RunbookRunContent } from '@/components/compliance/RunbookRunDetail'
import { Button } from '@deepguide-ai/ui/button'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/deprecated/workflows/$workflowId/executions/$jobId'
)({
  component: LegacyWorkflowExecutionRoute,
})

function LegacyWorkflowExecutionRoute() {
  const { jobId, workflowId, workspaceId } = useParams({ strict: false }) as {
    jobId: string
    workflowId: string
    workspaceId: string
  }

  return (
    <div className='min-h-screen bg-background'>
      <div className='mx-auto max-w-[1120px] px-6 py-6'>
        <div className='mb-4 flex items-center gap-3'>
          <Button asChild size='sm' variant='outline'>
            <Link
              to='/workspaces/$workspaceId/screenata/runbooks/$runbookId'
              params={{ workspaceId, runbookId: workflowId }}
            >
              <ArrowLeft className='h-4 w-4' />
              Open runbook
            </Link>
          </Button>
        </div>

        <div className='overflow-hidden rounded-sm border border-border bg-card'>
          <RunbookRunContent runId={jobId} layout='embedded' />
        </div>
      </div>
    </div>
  )
}
